export const IVIEW_PLACEHOLDER_TYPES = {
  ENCOURAGING: 0,
  SEARCH: 1,
  SELECTION: 2,
  PIN_IN_TEAMS: 3,
  REDIRECT: 4,
  NOT_FOUND: 5,
  INACTIVITY: 6,
}
